const items = {
  "course.basic.info.label": "基本信息",
  "course.exp.start.label": "起始经验",
  "course.exp.end.label": "结束经验",
  "course.exp.current.label": "当前经验",
  "course.member.status.none.label": " ",
  "course.member.status.normal.label": "报名成功",
  "course.member.status.joined.label": "已经参加了",
  "course.member.status.join.button": "参课",
  "course.member.status.join.message":
    "本课程为自学课程，加入后无需录取，随时开始学习。确定参加{course}吗？",
  "course.member.status.applied.label": "已经报名",
  "course.member.status.apply.button": "报名",
  "course.member.status.apply.message":
    "报名后您的学习记录将会向本课程组织者公开，需组织者审核录取后方可开始学习。确定报名{course}吗？",
  "course.member.status.canceled.label": "已经取消",
  "course.member.status.cancel.button": "取消",
  "course.member.status.cancel.message": "要取消{course}的报名吗？",
  "course.member.status.agreed.label": "已接受邀请",
  "course.member.status.agree.button": "接受邀请",
  "course.member.status.agree.message": "要接受作为{course}的{role}的邀请吗？",
  "course.member.status.disagreed.label": "已拒绝邀请",
  "course.member.status.disagree.button": "拒绝邀请",
  "course.member.status.disagree.message": "要拒绝作为{course}的{role}邀请吗？",
  "course.member.status.left.label": "已退出",
  "course.member.status.leave.button": "退出",
  "course.member.status.leave.message": "要退出{course}吗？",
  "course.member.status.invited.label": "已经邀请",
  "course.member.status.invite.button": "邀请",
  "course.member.status.invite.message": "要邀请{user}成为{role}吗？",
  "course.member.status.revoked.label": "已经撤销邀请",
  "course.member.status.revoke.button": "撤销邀请",
  "course.member.status.revoke.message": "要撤销{user}成为{role}吗？",
  "course.member.status.accepted.label": "已录取",
  "course.member.status.accept.button": "录取",
  "course.member.status.accept.message": "录取{user}吗？",
  "course.member.status.rejected.label": "未录取",
  "course.member.status.reject.button": "不录取",
  "course.member.status.reject.message": "不录取{user}吗？",
  "course.member.status.blocked.label": "已清退",
  "course.member.status.block.button": "清退",
  "course.member.status.block.message": "清退{user}吗？",
  "course.join.mode.invite.label": "仅限邀请",
  "course.join.mode.invite.message": "本课程仅限内部邀请。",
  "course.join.mode.manual.label": "人工审核",
  "course.join.mode.manual.message":
    "本课程为报名后人工审核课程。报名后请等待组织者审核。",
  "course.join.mode.manual.user-accept.message": "您确定要接受课程邀请吗？",
  "course.join.mode.open.label": "开放自学",
  "course.join.mode.open.message": "本课程为开放课程。加入后可以立即开始学习。",
  "course.leave.message": "离开后将无法再次报名，您确定要离开吗？",
  "course.rejected.message": "拒绝后将无法再次报名，您确定要拒绝吗？",
  "course.exp.request.none.label": "无需",
  "course.exp.request.none.message": " ",
  "course.exp.request.begin-end.label": "起始和结束",
  "course.exp.request.begin-end.message":
    "课程组织者需要查看您的课程起始和结束的学习时长。报名意味着您同意。",
  "course.exp.request.daily.label": "每日",
  "course.exp.request.daily.message":
    "课程组织者需要查看您在课程期间的每日学习时长。报名意味着您同意。",
  "course.table.count.member.title": "成员数",
  "course.table.count.progressing.title": "待审核",
  "course.timeline.all": "全部参课记录",
  "course.timeline.current": "当前课程",
  "course.channel.unbound": "未绑定",
  "course.member.timeline": "参课记录",
};

export default items;
